export const graficoLinhasStyles = {}
